// Meta (Facebook/Instagram) Pixel, for measuring ad results. Off until
// REACT_APP_META_PIXEL_ID is set. The ID is public, like the pixel itself.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";
export const metaPixelEnabled = PIXEL_ID.length > 0;

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

/** Meta's standard loader: queue calls until fbevents.js arrives. */
export const initMetaPixel = () => {
  if (!metaPixelEnabled || window.fbq) return;
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  } as Fbq;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  fbq("init", PIXEL_ID);
};

export const trackPageView = () => window.fbq?.("track", "PageView");

/**
 * Standard events: CompleteRegistration, StartTrial, Purchase. The server
 * reports the same events with the same eventId, so Meta counts each once.
 */
export const trackMetaEvent = (
  name: string,
  params?: Record<string, unknown>,
  eventId?: string
) =>
  eventId
    ? window.fbq?.("track", name, params ?? {}, { eventID: eventId })
    : window.fbq?.("track", name, params);

const readCookie = (name: string) =>
  document.cookie
    .split("; ")
    .find((part) => part.startsWith(`${name}=`))
    ?.slice(name.length + 1);

/**
 * Meta's browser and ad-click cookies, sent with a website sign-up so the
 * server's events can be matched to the same visitor.
 */
export const metaCookies = () => ({
  fbp: readCookie("_fbp"),
  fbc: readCookie("_fbc"),
});
